import React, { useEffect } from "react";
import insertScript from "helpers/insert-script";
import Loader from "components/loader";

const OrderTracking = ({ data }) => {
	useEffect(() => {
		insertScript("head", "https://tracking.parcelperform.com/pp-widget.js?order-id=123", "pp-widget-script");

		// We need to clean up this script when changing language so the correct language is loaded
		return () => {
			const scriptElement = document.getElementById("pp-widget-script");
			if (scriptElement) {
				scriptElement.parentNode.removeChild(scriptElement);
			}
		};
	}, []);

	return (
		<div id="pp-widget-root" data-cms-slug={data.language}>
			<Loader ring={true} />
		</div>
	);
};

export default OrderTracking;
